import {BaseClient} from '../utils/base-client';

class UserDetailsClient extends BaseClient {
  buildEndpoint() {
    return `api/app/me/`;
  }

  buildQueryParams({projectID}) {
    return {
      // eslint-disable-next-line
      project_id: projectID,
    };
  }

  processResponse(response) {
    return response.results;
  }
}

export default new UserDetailsClient();
